import get from 'lodash.get'

import { de } from './common'

type DotPrefix<T extends string> = T extends '' ? '' : `.${T}`

type DotNestedKeys<T> = (
  T extends object
    ? {
        [K in Exclude<keyof T, symbol>]: `${K}${DotPrefix<DotNestedKeys<T[K]>>}`
      }[Exclude<keyof T, symbol>]
    : ''
) extends infer D
  ? Extract<D, string>
  : never

export type DictionaryKey = DotNestedKeys<typeof de>

interface DynamicValue {
  [key: string]: string | number
}

export function t(
  translationKey: DictionaryKey,
  dynamicValue?: DynamicValue
): string {
  if (dynamicValue) {
    const [[key, value]] = Object.entries(dynamicValue)
    return get(de, translationKey).replace(`{{${key}}}`, value)
  }
  return get(de, translationKey)
}
